import useUserSettings from '@/hooks/use-user-settings.hook';
import { FC, useMemo } from 'react';
import Select from '../form/select';
import Text from '../text';

interface Props {
  onChange: (agentId: string) => void;
  value: string;
  label?: string;
}

const AgentSelect: FC<Props> = ({ onChange, value, label = 'Assistant' }) => {
  const { agents, isLoading } = useUserSettings();

  // append the default org portal branding as the default agent to the list of available agents
  const agentOpts = useMemo(() => {
    return agents.map(({ id, portal }) => {
      const {
        badge: { title },
      } = portal;
      return {
        value: id,
        label: title,
      };
    });
  }, [agents]);

  const handleRenderValue = (value: string) => {
    const agent = agents.find(({ id }) => id === value);

    if (!agent) {
      return <></>;
    }

    return <Text dotdot>{agent.portal?.badge?.title}</Text>;
  };

  return (
    <Select
      name="agentId"
      label={label}
      value={value}
      options={agentOpts}
      onChange={onChange}
      onRenderValue={handleRenderValue}
      fullWidth
      size="small"
      loading={isLoading}
    />
  );
};

export default AgentSelect;
